<div class="header-actions">
  <div *ngIf="columnHeader['AlarmCategory'] != null && columnHeader['AlarmCategory'].filterable && filterOptions['AlarmCategory'] != null && filterOptions['AlarmCategory'].length > 0" class="status-flag-section">
    <mat-chip-listbox class="status-flag-set-alarms" [multiple]="false" >
      <ng-container *ngFor="let flag of filterOptions['AlarmCategory']">
        <mat-chip-option *ngIf="flag != 'System'" style="width: fit-content" [ngClass]="{'status-flag': columnHeader['AlarmCategory'].activeFilter != flag}" [value]="flag" (click)="selectChip('AlarmCategory', flag)">
        <span>{{ flag }}</span>
      </mat-chip-option>
      </ng-container>
    </mat-chip-listbox>
  </div>

  <div class="col-10 header-left-section">
    <div class="search-pill">
      <input class="search-pill-input" [(ngModel)]="filtroInput" placeholder="Filtro" (keyup)="applyFilter($event)" />
      <mat-icon aria-hidden="false" class="btn-buscar" (click)="applyFilter()">search</mat-icon>
      <mat-icon aria-hidden="false" class="btn-limpiar" (click)="refreshFilter()">cancel</mat-icon>
    </div>
  </div>
</div>

<div class="table-section">
  <loading [isLoading]="isLoading"></loading>
  <table #miTabla mat-table [dataSource]="mainDataSource" matSort class="mat-elevation-z8">
    <ng-container
      [matColumnDef]="dataKeys"
      *ngFor="let dataKeys of objectKeys(columnHeader)"
    >
    
      <ng-container [ngSwitch]="dataKeys">
        <ng-container *ngSwitchDefault>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div style="display: flex; flex-direction: column;">
              <div style="display: flex; flex-direction: row; align-items: center;">

                <div>
                  {{ columnHeader[dataKeys].displayName }}
                </div>

                <button matMenuTriggerRestoreFocus="false" *ngIf="columnHeader[dataKeys].filterable && dataKeys != 'AlarmCategory'" mat-icon-button [matMenuTriggerFor]="filterMenu" (click)="setCurrentColumn(dataKeys)">
                  <!-- <mat-icon>filter_list</mat-icon> -->
                  <mat-icon *ngIf="!columnHeader[dataKeys].activeFilter" >filter_alt_on</mat-icon>
                  <mat-icon *ngIf="columnHeader[dataKeys].activeFilter" >filter_alt_off</mat-icon>
                </button>
  
              </div>

              <div>
                <span *ngIf="columnHeader[dataKeys].activeFilter">({{ columnHeader[dataKeys].activeFilter }})</span>
              </div>

            </div>
          </th>
          <td  mat-cell *matCellDef="let element; let i = index">
            <div >{{ element[dataKeys] }}</div>
          </td>
        </ng-container>

        <ng-container *ngSwitchCase="'Icon'">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element; let i = index" >
            <mat-icon>{{ element[dataKeys] }}</mat-icon>
          </td>
        </ng-container>
  
        <!-- <ng-container *ngSwitchCase="'Actions'">
          <th mat-header-cell *matHeaderCellDef>{{ columnHeader[dataKeys].displayName }}</th>
          <td mat-cell *matCellDef="let row" >
            <div class="actions">
              <mat-icon class="btn-edit" (click)="handleClick(row, 'edit')" *ngIf="row.IsEditable">edit</mat-icon>
              <mat-icon class="btn-idelete" (click)="handleClick(row, 'delete')" *ngIf="row.IsHideable">remove_red_eye</mat-icon>
            </div>
          </td>
        </ng-container> -->

        <ng-container *ngSwitchCase="'AlarmDetails'">
          <th mat-header-cell *matHeaderCellDef>{{ columnHeader[dataKeys].displayName }}</th>
          <td mat-cell *matCellDef="let row" >
            <div *ngIf="row.IdAlarm != 0 " class="actions">
              <mat-icon class="btn-edit" (click)="alarmDetailPopUp(row)">event_note</mat-icon>
            </div>
            <div *ngIf="row.IdAlarm == 0" class="actions">
              <label for="">sin alarma</label>
            </div>
          </td>
        </ng-container>


      </ng-container>
    </ng-container>
  
    
    <tr class="mat-row" *matNoDataRow >
      <td class="mat-cell" colspan="4">No se encontraron datos</td>
    </tr>
  
    <tr mat-header-row *matHeaderRowDef="objectKeys(columnHeader)"></tr>
    <tr mat-row *matRowDef="let row; columns: objectKeys(columnHeader)" 
                [ngClass]="{'alarmed-row': row['statusAlarm'] === 'Alarmed', 'standby-row': row['statusAlarm'] === 'StandBy', 'inactiveUser': isInactive}"></tr>
  </table>
</div>

<mat-paginator 
  [pageSize]="10"
  [length]="mainTotalCount"
  (page)="nextPage($event)"
></mat-paginator>

<mat-menu #filterMenu="matMenu">
  <!-- Campo de entrada para filtrar las opciones -->
  <div style="padding: 3px;" (click)="$event.stopPropagation()">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Buscar</mat-label>
      <input matInput [(ngModel)]="filterSearchText" placeholder="Escribe para filtrar"  />
    </mat-form-field>
  </div>

  <!-- opcion de limpiado -->
  <button mat-menu-item (click)="clearColumnFilter()">---Limpiar---</button>

  <!-- se usa un pipe con la cadena del buscador para traer el array dinámico  -->
  <ng-container *ngFor="let option of (filterOptions[currentColumn] | filterArray: filterSearchText)">
    <button mat-menu-item (click)="applyColumnFilter(option)">{{ option }}</button>
  </ng-container>
</mat-menu>